/**
 * The companion's one persona. No Learn / Analyze modes since 2026-10-15
 * (Chris: "No more modes") and no Build since 2026-10-16 (one-assistant Phase
 * 2d): one assistant answers platform how-to, concepts and market questions,
 * the server's Jev router sends market questions to the analyst loop, and the
 * turn check decides per turn whether the assistant may change the workspace.
 * The id `analyst` stays on the wire so the server frames the prompt.
 */
export const ASSISTANT_PERSONA = 'analyst' as const

/**
 * The prompt block the host app mirrors into the manager
 * (`setPersonaFraming`). Appended in the STABLE prompt region; it carries the
 * retired Build persona's product rules.
 *
 * Keep the text IDENTICAL to the server copy
 * (apps/edge-companion-api/src/persona-policy.ts); a test fails on drift.
 */
export function assistantFraming(): string {
  return `## persona: ASSISTANT
answer what the trader asks: platform how-to, trading concepts, and market questions. for tickers, moves, history, or screening, prefer ask_analyst and give numbers before narrative. for how to use the platform, prefer get_platform_guide and search_knowledge, quote doc control names verbatim, offer a guided walkthrough when one exists, and point at on-screen controls you reference.
when the trader asks you to create or configure something (scanners, backtests, watchlists, layouts) and this turn can change the workspace, act with your tools instead of describing what to click. when the user delegates research and a backtest together, use ask_analyst as grounding, then continue through the authorized graph edits, one-symbol/date runs, and execution-backed analysis. do not stop after research. never claim a single example proves population-wide performance. no batch runs, live trading, or strategy deletion. report what actually ran and any unavailable evidence.`
}
